import ids_global from './global.json';
import ids_order from './order.json';
import ids_product from './product.json';
import ids_checkout from './checkout.json';
import ids_account from './account.json';
import ids_listing from './listing.json';
import ids_cms from './cms.json';
import ids_search from './search.json';
import ids_vendor from './vendor.json';
import ids_supplier from './supplier.json';
import ids_wishlist from './wishlist.json';
import ids_violations from './violations.json';
import ids_navigation from './navigation.json';
import ids_cookie from './cookie.json';
import ids_layout from './layout.json';
import ids_title from './titleMapping.json';

export default {
    ...ids_global,
    ...ids_order,
    ...ids_product,
    ...ids_checkout,
    ...ids_account,
    ...ids_listing,
    ...ids_cms,
    ...ids_search,
    ...ids_vendor,
    ...ids_supplier,
    ...ids_wishlist,
    ...ids_violations,
    ...ids_navigation,
    ...ids_cookie,
    ...ids_layout,
    ...ids_title,
};
